import styled, { css } from 'styled-components'

import { minmedia } from '../../styles/media-queries'
import { bordergray, white, red } from '../../styles/colors'
import { Wrapper as CheckBoxWrapper } from '../CheckBox/styles'

export const StyledForm = styled.form`
  display: flex;
  flex-wrap: wrap;

  ${CheckBoxWrapper} {
    padding-left: 1rem;
  }

  ${minmedia.large`
    background: ${white};
    padding: 2.5rem;
    border: 1px solid ${bordergray};
    border-radius: .25rem;
  `};
`

export const PasswordFeedback = styled.div`
  margin-bottom: 1rem;
  margin-top: -0.5rem;
  color: ${red};
  font-size: 14px;
`

export const InputFeedback = styled.div`
  margin-bottom: 1rem;
  margin-top: -0.5rem;
  color: ${red};
  font-size: 14px;
`

export const Inner = styled.div`
  flex: 1;

  & > div {
    margin-bottom: 1.5rem;

    &:last-child {
      margin-bottom: 0;
    }
  }
`

export const Title = styled.p`
  margin-top: 2.5rem;
  font-weight: 400;
  &:first-child {
    margin-top: 0;
  }
`

export const Footer = styled.div`
  display: flex;
  flex-wrap: no-wrap;
  align-items: center;
`

export const ButtonContainer = styled.div``

export const Feedback = styled.p`
  transition: all 0.5s;
  margin-bottom: 0;
  margin-left: 1rem;
  font-weight: 400;

  visibility: hidden;
  z-index: -1;
  opacity: 0;

  ${props =>
    props.saved &&
    css`
      visibility: visible;
      z-index: 1;
      opacity: 1;
    `};
`

export const IconContainer = styled.div`
  width: 100%;
  text-align: center;
  margin-bottom: 2rem;

  ${minmedia.large`
    width: 300px;
    margin-bottom: 0; //reset
    margin-top: 1.5rem;
    order: 2;
  `} svg {
    width: 125px;
    height: 125px;

    ${minmedia.medium`
      width: 165px;
      height: 165px;
    `} ${minmedia.large`
      width: 190px;
      height: 190px;
    `};
  }
`



// WEBPACK FOOTER //
// ./src/components/Form/styles.js